import React from "react";
import { Select, DatePicker, Button, Space } from "antd";
import { SearchOutlined, PrinterOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import ROLES from "../../../../../../constants/roles";

const { RangePicker } = DatePicker;

const AttendanceReportFilter = ({
  branches = [],
  departments = [],
  selectedBranch,
  selectedDepartment,
  dateRange,
  employeeSearch,
  onBranchChange,
  onDepartmentChange,
  onDateRangeChange,
  onEmployeeSearchChange,
  onSearch,
  onExportPDF,
  onExportExcel,
  onPrint,
  isLoading,
  showEmployeeSearch = false,
  userRole = "",
  hasSearched = false,
}) => {
  // Hide branch for HOD and Manager roles
  const showBranch = ![ROLES.MANAGER, ROLES.HOD].includes(userRole);
  // Hide department for HOD role
  const showDepartment = userRole !== ROLES.HOD;

  return (
    <div className="row mb-4 align-items-end g-3">
      {showBranch && (
        <div className="col">
          <label className="form-label">Branch</label>
          <Select
            placeholder="Select Branch"
            style={{ width: "100%" }}
            onChange={onBranchChange}
            value={selectedBranch}
            allowClear
          >
            {branches.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      )}

      <div className="col">
        <label className="form-label">Date Range</label>
        <RangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          format="YYYY-MM-DD"
          style={{ width: "100%" }}
          allowClear={false}
        />
      </div>

      {showEmployeeSearch && (
        <div className="col">
          <label className="form-label">Employee Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search employee..."
            value={employeeSearch}
            onChange={(e) => onEmployeeSearchChange(e.target.value)}
          />
        </div>
      )}

      {showDepartment && (
        <div className="col">
          <label className="form-label">Department</label>
          <Select
            placeholder="Select Department"
            style={{ width: "100%" }}
            onChange={onDepartmentChange}
            value={selectedDepartment}
            allowClear
          >
            {departments.map((dept) => (
              <Select.Option key={dept.id} value={dept.id}>
                {dept.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      )}

      <div className="col-auto">
        <Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={onSearch}
            loading={isLoading}
          >
            SEARCH
          </Button>
        </Space>
      </div>

      {hasSearched && (
        <div className="col-auto">
          <Space>
            {onExportExcel && (
              <Button
                icon={<FileExcelOutlined style={{ color: "#217346" }} />}
                onClick={onExportExcel}
                title="Export to Excel"
              >
                Excel
              </Button>
            )}
            {onExportPDF && (
              <Button
                icon={<FilePdfOutlined style={{ color: "#ff4d4f" }} />}
                onClick={onExportPDF}
                title="Export to PDF"
              >
                PDF
              </Button>
            )}
            {onPrint && (
              <Button
                icon={<PrinterOutlined />}
                onClick={onPrint}
                title="Print"
              >
                Print
              </Button>
            )}
          </Space>
        </div>
      )}
    </div>
  );
};

export default AttendanceReportFilter;
